import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssDialogComponent } from './dialog.component';
import { UmssDialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { UmssDialogFooterComponent } from '../dialog-footer/dialog-footer.component';
import { ConfirmationService } from '../../services/confirmation.service';

@Component({
  selector: 'umss-confirm-dialog',
  standalone: true,
  imports: [
    CommonModule,
    UmssDialogComponent,
    UmssDialogHeaderComponent,
    UmssDialogFooterComponent
  ],
  template: `
    <umss-dialog
      [open]="isOpen()"
      [closable]="true"
      [backdropClosable]="false"
      size="Small"
      (onClose)="handleChoice(false)"
    >
      <umss-dialog-header [title]="options()?.title || 'Confirm'" />

      <div class="confirm-content">
        <p>{{ options()?.message }}</p>
      </div>

      <umss-dialog-footer
        [primaryButtonLabel]="options()?.confirmLabel || 'Confirm'"
        [secondaryButtonLabel]="options()?.cancelLabel || 'Cancel'"
        [primaryButtonVariant]="confirmButtonVariant()"
        secondaryButtonVariant="Outline"
        [loading]="loading()"
        (onPrimaryClick)="handleChoice(true)"
        (onSecondaryClick)="handleChoice(false)"
      />
    </umss-dialog>
  `,
  styles: [
    `
      .confirm-content {
        padding: var(--spacing-4);
        p {
          margin: 0;
          color: var(--color-text-text-primary);
          font-size: var(--fs-14);
          line-height: var(--lh-20);
          overflow-wrap: anywhere;
          user-select: text;
          white-space: pre-wrap;
        }
      }
      .footer-actions {
        display: flex;
        gap: var(--spacing-3);
        justify-content: flex-end;
        width: 100%;
      }
    `
  ]
})
export class UmssConfirmDialogComponent {
  private service = inject(ConfirmationService);

  isOpen = this.service.isOpen;
  options = this.service.options;
  loading = this.service.loading;

  confirmButtonVariant = computed(() => {
    const type = this.options()?.type;
    if (type === 'Error') return 'Destructive';
    return 'Primary';
  });

  handleChoice(choice: boolean) {
    this.service.handleChoice(choice);
  }
}
